import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceHigh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceHigh"><Path d="M7.49911 3.5V20.5M3.5 9.5V14.5M11.9991 7.5V16.5M16.5 5.5V18.5M20.5 9.5V14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoiceHigh;
